import React from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { DocumentAnalyser } from '@/components/ai/DocumentAnalyser';

const DocumentAnalyserPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <DocumentAnalyser />
      </main>
      <Footer />
    </div>
  );
};

export default DocumentAnalyserPage;
